import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { callApi } from "../../api";
import { useAuth } from "../useAuth";

// const tempWaivers = [
//   {
//     name: "COVID-19 Liability Waiver",
//     id: 1,
//     description: "waiver form for Covid-19",
//     title: "COVID-19 Liability Waiver",
//     intro_text:
//       "The World Health Organization has declared the novel Coronavirus (COVID-19) a worldwide pandemic. Due to its capacity to transmit from person-to-person through respiratory droplets, the government has set recommendations, guidelines, and some prohibitions which Namuna Beauty adheres to comply.",
//     terms: [
//       {
//         text: "I am fully and personally responsible for my own safety and actions while and during may participation and I recognize that I may be in any case be at risk of contracting COVID-19.",
//         type: "bool",
//         acceptableValues: [true],
//         trueLabel: "Agree",
//         falseLabel: "Disagree",
//       },
//       {
//         text: "Organization from and against any and all costs, expenses, damages, lawsuits, and/or liabilities or claims arising whether directly or indirectly from or related to any and all claims made by or against any of the released party due to injury, loss, or death from or related to COVID-19.",
//         type: "bool",
//         acceptableValues: [true],
//         trueLabel: "Agree",
//         falseLabel: "Disagree",
//       },
//     ],
//     closing_text:
//       "I hereby release and agree to hold Namuna Beauty harmless from, and waive on behalf of myself, my heirs, and any personal representatives any and all causes of action, claims, demands, damages, costs, expenses and compensation for damage or loss to myself and/or property that may be caused by any act, or failure to act of the salon, or that may otherwise arise in any way in connection with any services received from Namuna Beauty.",
//   },
//   {
//     name: "Test Waiver",
//     id: 2,
//     description: "this is a test description",
//     title: "COVID-19 Liability Waiver",
//     intro_text:
//       "The World Health Organization has declared the novel Coronavirus (COVID-19) a worldwide pandemic. Due to its capacity to transmit from person-to-person through respiratory droplets, the government has set recommendations, guidelines, and some prohibitions which Namuna Beauty adheres to comply.",
//     terms: [
//       {
//         text: "I am fully and personally responsible for my own safety and actions while and during may participation and I recognize that I may be in any case be at risk of contracting COVID-19.",
//         type: "bool",
//         acceptableValues: [true],
//         trueLabel: "Agree",
//         falseLabel: "Disagree",
//       },
//       {
//         text: "Organization from and against any and all costs, expenses, damages, lawsuits, and/or liabilities or claims arising whether directly or indirectly from or related to any and all claims made by or against any of the released party due to injury, loss, or death from or related to COVID-19.",
//         type: "bool",
//         acceptableValues: [true],
//         trueLabel: "Agree",
//         falseLabel: "Disagree",
//       },
//     ],
//     closing_text:
//       "I hereby release and agree to hold Namuna Beauty harmless from, and waive on behalf of myself, my heirs, and any personal representatives any and all causes of action, claims, demands, damages, costs, expenses and compensation for damage or loss to myself and/or property that may be caused by any act, or failure to act of the salon, or that may otherwise arise in any way in connection with any services received from Namuna Beauty.",
//   },
// ];

export default () => {
  const [waivers, setWaivers] = useState([]);
  const { selectedBusiness } = useAuth();

  const waiversEnabled = !!selectedBusiness?.info?.waiversEnabled;

  const getWaivers = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:NID:/waivers/get`
    );
    if (res && res.status === true) {
      setWaivers(res.data);
    } else {
      toast.error((res && res.message) || "Failed to fetch waivers!");
      setWaivers([]);
    }
  };

  const getWaiverVersionHistory = async (id) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:NID:/waivers/${id}/version/get`
    );
    return res;
  };

  const getSignedWaiversReport = async (start, end) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=${encodeURIComponent(`:NID:/waivers/report/get?start=${start}&end=${end}`)}`,
      "GET",
      null,
      null,
      { start, end }
    );
    return res;
  };

  const getSignedWaiversInfo = async (wid, page, limit) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/iorequest?dest=${encodeURIComponent(`:NID:/waivers/${wid}/get-info?page=${page}&limit=${limit}`)}`,
      "GET"
    );
    return res;
  };

  const addWaiver = async (data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:NID:/:BID:/waiver/create`,
      "POST",
      data
    );
    if (res && res.status === true) {
      setWaivers([...(waivers || []), res.data]);
    } else {
      toast.error((res && res.message) || "Failed to create waiver!");
    }
  };

  const saveWaiver = async (data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:NID:/:BID:/waiver/${data?.id}/update`,
      "POST",
      { ...data, version: undefined }
    );
    if (res && res.status === true) {
      setWaivers(
        (waivers || [])?.map((x) => {
          if (x.id === data?.id) return { ...x, ...data };
          return x;
        })
      );
    } else {
      toast.error((res && res.message) || "Failed to modify waiver!");
    }
  };

  const updateWaiverTemplate = async (data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:NID:/waivertemplate/${data?.id}/update`,
      "POST",
      data
    );
    if (res && res.status === true) {
      setWaivers(
        (waivers || [])?.map((x) => {
          if (x.id === data?.id) return { ...x, ...data };
          return x;
        })
      );
    } else {
      toast.error((res && res.message) || "Failed to update waiver!");
    }
  };

  const deleteWaiver = async (id) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:NID:/:BID:/waiver/${id}/delete`,
      "POST"
    );
    if (res && res.status === true) {
      setWaivers((waivers || [])?.filter((x) => x.id !== id));
    } else {
      toast.error((res && res.message) || "Failed to delete waiver!");
    }
  };

  const getWaiversForService = async (sid) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:BID:/service/${sid}/waiver/get`
    );
    return res;
  };

  const getServicesByWaiver = async (wid) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:BID:/waiver/${wid}/service/get`
    );
    return res;
  }

  const getWaiversForCategory = async (cid) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:BID:/category/${cid}/waiver/get`
    );
    return res;
  };

  const updateWaiversForService = async (sid, wids) => {
    if (!wids) return null;
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:BID:/service/${sid}/waiver/update`,
      "POST",
      { waiverIds: wids }
    );
    return res;
  };

  const updateServiceWaiversByWaiverId = async (wid, toAddData, toRemoveIds) => {
    if (!wid) return null;
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:BID:/waiver/${wid}/services/update`,
      "POST",
      { toAddData, toRemoveIds }
    );
    return res;
  };

  const updateWaiversForCategory = async (cid, wids) => {
    if (!wids) return null;
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=:BID:/category/${cid}/waiver/update`,
      "POST",
      { waiverIds: wids }
    );
    return res;
  };

  useEffect(() => {
    setWaivers([]);
  }, [selectedBusiness?.id]);

  return {
    waivers,
    waiversEnabled,
    getWaivers,
    addWaiver,
    saveWaiver,
    deleteWaiver,
    getSignedWaiversReport,
    getSignedWaiversInfo,
    updateWaiverTemplate,
    getWaiverVersionHistory,
    getWaiversForService,
    getServicesByWaiver,
    updateWaiversForService,
    updateServiceWaiversByWaiverId,
    getWaiversForCategory,
    updateWaiversForCategory,
  };
};
